import angular from 'angular';

import shopAppointmentFormSubmitter from './shop-appointment-form-submitter/shop-appointment-form-submitter.component.js';
import shopAppointmentDatePickerComponent from './shop-appointment-date-picker/shop-appointment-date-picker.component.js';
import shopAppointmentReasons from './shop-appointment-reasons/shop-appointment-reasons.component.js';

import createAppointmentComponent from './create-appointment.component.js';
import CreateAppointmentServ from './create-appointment.serv.js';

export default angular.module('createAppointment', [])
	.directive('shopAppointmentFormSubmitter', shopAppointmentFormSubmitter)
	.directive('shopAppointmentDatePicker', shopAppointmentDatePickerComponent)
	.directive('shopAppointmentReasons', shopAppointmentReasons)
	.directive('createAppointment', createAppointmentComponent)
	.service('createAppointmentServ', CreateAppointmentServ)
	.name;